var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVertex = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M8.002 15.563c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v6.563c0 .55-.45 1-1 1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M16.002 29a1 1 0 0 1-.537-.156l-11-7a1 1 0 0 1 1.075-1.687l10.462 6.656 10.463-6.657a1.006 1.006 0 0 1 1.38.306 1.006 1.006 0 0 1-.305 1.382l-11 7a1 1 0 0 1-.538.156"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M16.002 24.625c-.55 0-1-.45-1-1v-4.569c0-.55.45-1 1-1s1 .45 1 1v4.569c0 .55-.45 1-1 1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M8.002 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.002 19.563a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M24.015 19.625c-.55 0-1-.444-1-1L23.002 12a.999.999 0 1 1 2 0l.013 6.625c0 .55-.444 1-1 1M24.002 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M24.002 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M20.002 14.063c-.55 0-1-.45-1-1V6.625c0-.55.45-1 1-1s1 .45 1 1v6.438c0 .55-.45 1-1 1"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M16.002 12.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2M16.002 16.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M20.002 18.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2M20.002 22.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12.002 14.063c-.55 0-1-.45-1-1V6.625c0-.55.45-1 1-1s1 .45 1 1v6.438c0 .55-.45 1-1 1M12.002 18.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12.002 22.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVertex);
export default ForwardRef;